<tec-modal
	[isVisible]="true"
	[title]="'PROCESSES.DETAIL.BROWSER_DETAIL' | translate"
	(closeEvent)="closeModal()"
>
	<ng-container body>
		@if (device) {
			<div class="grid grid-i2">
				<tec-info-group [label]="'PROCESSES.DETAIL.BROWSER_MODAL_USER_AGENT' | translate">
					<span>{{ device.user_agent || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
				</tec-info-group>
				@if (device.user_agent_info) {
					<tec-info-group [label]="'PROCESSES.DETAIL.BROWSER' | translate">
						<span>{{ device.user_agent_info.browser }}</span>
					</tec-info-group>
					<tec-info-group [label]="'PROCESSES.DETAIL.BROWSER_VERSION' | translate">
						<span>{{ device.user_agent_info.version }}</span>
					</tec-info-group>
					<tec-info-group [label]="'PROCESSES.DETAIL.BROWSER_OS' | translate">
						<span>{{ device.user_agent_info.os }}</span>
					</tec-info-group>
					<tec-info-group [label]="'PROCESSES.DETAIL.BROWSER_DEVICE_TYPE' | translate">
						<span>{{ 'PROCESSES.DETAIL.DEVICE_TYPE_' + device.user_agent_info.deviceType | translate }}</span>
					</tec-info-group>
				}
			</div>
		}
	</ng-container>
</tec-modal>
